import { ready } from '../ready/ready.js';
import { isAndroid, isIphone } from '../utils/webview.js';
import { fabricAndroid } from './android/index.js';
import { fabricHarmony } from './harmony/index.js';
import { fabricIos } from './ios/index.js';
import { type WebviewJavascriptBridgeApi } from './type.api.js';
export * from './type.api.js';
export * from './type.bridge.js';
export * from './type.builtin.js';

export const core: WebviewJavascriptBridgeApi = isIphone()
  ? fabricIos
  : isAndroid()
    ? fabricAndroid
    : fabricHarmony;
// FIXME: 考虑到我们的代码会通过 modularImport的优化, `ready.ts`再业务未使用的时候, 并不会到加载到内存.
// 从而导致`DOMContentLoaded`并未被注册.
// 确保我们在业务应用中无定义`ready()`的时候, Native提前发送过来的pending的消息又机会得到处理, 如: onShow, onLoad, onHide,...
document.addEventListener('DOMContentLoaded', () => {
  // 延迟500毫秒, 500毫秒足够`DOM`加载完毕react在渲染时间(useEffect(()=>, []))
  // 如果我提前执行了ready, 可能导致subscription订阅的方法在还未注册成功就被无效消费掉了.
  setTimeout(ready, 500);
});
